<template>
    <main-content-wrapper>
        <h1 class="text-md-center" v-if="!was_password_changed">Zahteva po spremembi gesla</h1>
        <h1 class="text-md-center" v-if="was_password_changed">Postopek uspešno zaključen</h1>
        <p class="text-md-center" v-if="!was_password_changed">Zaradi varnosti vašega računa je bila zahtevana sprememba trenutnega gesla.</p>
        <empty-space/>
        <template v-if="!was_password_changed">
            <v-alert
                    v-if="invalid_error_message"
                    :value="invalid_error_message"
                    type="error"
            >
                {{ invalid_error_message }}
            </v-alert>
            <v-form ref="form" v-model="valid" @submit.prevent="">
                <password-field v-model="password" :rules="newPasswordRules" label="Novo geslo" v-on:keypress.enter="doChangePassword" required autofocus />
                <password-field v-model="password_again" :rules="[checkNewPasswordAgain]" label="Ponovno vpisano novo geslo" v-on:keypress.enter="doChangePassword" required />

                <div>
                    <empty-space />
                    <split-content text="Ostali pomembni podatki" />
                    <empty-space />
                    <v-alert
                            v-if="confirmation_error_message"
                            :value="confirmation_error_message"
                            type="error"
                    >
                        {{ confirmation_error_message }}
                    </v-alert>
                    <template v-if="confirmation_step == 0">
                        <template v-if="confirmProcess=='email'">
                            <email-field v-model="email" label="Email" persistent-hint hint="" :rules="[checkEmail]" ref="email_input" :error-messages="email_error_messages" />
                            <p>Z vpisom vašega email naslova bo za vas ustvarjen polni spletni profil s katerim boste lahko koristili vse TUŠ online storitve. Na vpisani email naslov boste prejemali tudi pomembna obvestila ali si z njegovo pomočjo obnovili dostop v primeru pozabljenega gesla.</p>
                            <v-btn text small @click="confirmProcess='sms'" color="primary">Brez email naslova?</v-btn>
                        </template>
                        <template v-if="confirmProcess=='sms'">
                            <phone-number v-model="phoneNumber" label="Mobilna telefonska številka" required :rules="checkPhoneNumberRequired" validate-on-blur ></phone-number>
                            <p>Z vpisom vaše telefonske številke boste lahko v primeru izgube gesla obnovili svoj dostop.</p>
                            <v-btn text small @click="confirmProcess='email'" color="primary">Imate email naslov?</v-btn>
                        </template>
                        <empty-space />
                    </template>
                    <template v-if="confirmation_step == 1">
                        Na {{ confirmProcess }} smo vam poslali potrditveno kodo. Za nadaljevanje postopka prosimo vpišite to kodo.
                        <input-field v-model="confirmCode" label="Potrditvena koda" :rules="checkShortConfirmationCode" />
                    </template>
                    <template v-if="confirmation_step == 2">
                        <p>Hvala za potrditev. Poteka priprava računa. Prosimo počakajte...</p>
                        <empty-space />
                    </template>
                </div>

            </v-form>
            <v-btn depressed block color="primary_action" :loading="loading || confirmation_step==2" @click="doStepAction">{{ confirmButtonText }}</v-btn>
        </template>
        <template v-if="was_password_changed">
            <v-alert
                    type="success"
            >
                Geslo je bilo uspešno spremenjeno. Vnešeni podatki so bili shranjeni.
            </v-alert>
            <v-btn depressed block color="primary_action" @click="doNext">NADALJUJ</v-btn>
        </template>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import EmptySpace from "../components/EmptySpace";
    import PasswordField from "../components/PasswordField";
    import InputField from "../components/InputField";
    import EmailField from "../components/EmailField";
    import {userService, tusTeamService} from "../services";
    import validations from "../components/validations";
    import utils from "../store/utils";
    import Router from "../router";
    import PhoneNumber from "../components/PhoneNumber";
    import SplitContent from "../components/SplitContent";

    export default {
        name: "PasswordChangeRequested",
        components: {SplitContent, PhoneNumber, MainContentWrapper, PasswordField, InputField, EmptySpace, EmailField},
        data() {
            return {
                loading: false,
                email_error_messages: undefined,
                password: undefined,
                password_again: undefined,
                invalid_error_message: undefined,
                confirmation_error_message: undefined,
                was_password_changed: false,
                email: undefined,
                phoneNumber: undefined,
                confirmCode: undefined,
                confirmProcess: 'email',
                confirmation_step: 0,
                checkPhoneNumberRequired: validations.checkPhoneNumberRequired,
                checkShortConfirmationCode: validations.checkShortConfirmationCode
            }
        },
        created() {
            if (!this.needs_password_change){
                Router.push('/racun');
            }
        },
        computed: {
            needs_password_change: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user.needs_password_change'),
            confirmButtonText(){
                if (this.confirmation_step == 1){
                    return 'Potrdi vpisano kodo';
                }
                return 'Potrdi';
            }
        },
        methods: {
            checkNewPasswordAgain(v) {
                return validations.newPasswordCheckAgain(v, this.password);
            },
            doChangePassword(){
                let isValid = this.$refs.form.validate();
                if (isValid){
                    this.loading = true;
                    userService.changePassword(this.currentPassword, this.password).then((data) => {
                        this.was_password_changed = true;
                    }, (error) => {
                        this.invalid_error_message = error.message;
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            },
            doStepAction(){
                let isValid = this.$refs.form.validate();
                if (isValid) {
                    this.confirmation_error_message = undefined;
                    if (this.confirmation_step == 0) {
                        this.doSendConfirmation();
                    } else if (this.confirmation_step == 1) {
                        this.doConfirmCode();
                    } else {
                        alert('Uknown action!');
                    }
                }
            },
            doSendConfirmation(){
                if (this.confirmProcess == 'sms'){
                    tusTeamService.sendSMSConfirmationCode(this.phoneNumber).then(()=>{
                        this.confirmation_step = 1;
                    }, (error) =>{
                        this.confirmation_error_message = error.message;
                    });
                } else if (this.confirmProcess == 'email') {
                    tusTeamService.sendEmailConfirmationCode(this.email).then(()=>{
                        this.confirmation_step = 1;
                    }, (error) =>{
                        this.confirmation_error_message = error.message;
                    });
                } else {
                    console.error('Not supported process!')
                }
            },
            doConfirmCode(){
                tusTeamService.confirmEmailSMS(this.confirmCode).then((data)=>{
                    this.confirmation_step = 2;
                    this.doChangePassword()
                }, (error)=>{
                    this.confirmation_error_message = error.message;
                }).finally(()=>{

                });
            },
            doNext(){
                window.location.replace('/');
            },
            checkEmail(v){
                this.email_error_messages = [];
                let noError = validations.checkEmailAll(v);
                if (noError === true){
                    if (this.$refs['email_input'].hasError == false) {
                        userService.checkEmail(v).then(
                            data => {

                            },
                            error => {
                                if (error.message) {
                                    this.email_error_messages = [error.message];
                                } else {
                                    this.email_error_messages = ['Napaka pri preverjanju naslova.'];
                                }
                            }
                        );
                    }
                    return true;
                }
                return noError;
            },

        }
    }
</script>

<style scoped>

</style>